/*
 * Copyright (c) 2024-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import Mousetrap from "../../libraries/ShortcutHandling.js";
import {Subscription} from "../../Subscription.js";

class KeyPressed extends Component {
    constructor() {
        super();
        this.state = {
            isActive: false
        }

        this.sub = new Subscription()

    }

    componentDidMount() {
        this.sub.add(() => Mousetrap.bind(this.props.shortcut, (e) => {
            if (!this.state.isActive) {
                this.setState({isActive: true})
            }
        }, "keydown"));

        this.sub.add(() => Mousetrap.bind(this.props.shortcut, (e) => {
            if (this.state.isActive) {
                this.setState({isActive: false})
            }
        }, "keyup"));

        // if the window is losing focus, it is expected that the key is no longer pressed

        this.sub.add(() => window.addEventListener("blur", (event) => {
            if (this.state.isActive) {
                this.setState({isActive: false})
            }
        }), "windowBlur");

    }

    componentWillUnmount() {
        this.sub.unmount()
    }


    render() {
        return (
            <>
                {this.props.children(this.state.isActive)}
            </>
        );
    }
}

KeyPressed.propTypes = {};

KeyPressed.defaultProps = {};


export default KeyPressed;